export const colours = {
  blue: "#0077c1",
  blueDark: "#0077c1",
  blueLight: "#0096EA",
  blueLighter: "#3cb3f5",
  blueVeryLight: "#e0f2fc",
  blueVeryLightDarker: "#c6e6f8",
  greenLight: "#00b872",
  green: "#087d56",
  yellow: "#FFD234",
  white: "#FFFFFF",
  gray: "#9EA4B1",
  grayLight: "#D6DBE5",
  lighterGray: "#f6f6f8",
  darkGray: "#4E5157",
  black: "#1A1A1A",
  labelBorder: "#97B0C8",
  red: "#ce0606",
  orange: "rgba(206,80,46,0.99)",
  pink: "rgba(213,140,231,0.99)",
  darkRed: "#6e0b00",
  secondaryButtonPress: "#00659E",
  darkButtonPress: "#001B29",
}
